export default __webpack_public_path__ + "static/media/GraficoIcon.e70c9dff.svg";